<template>
  <div class="sticker">
    <span></span>
    <span></span>
    <div class="sticker__container">
      {{ $t('hero.chance') }}
      <div>{{ $t('hero.free') }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>